import React from 'react';
import { Link } from 'react-router-dom';
import PannellumViewer from '@/shared/components/PannellumViewer';
import { IronviewLogo } from '@/shared/components/IronviewLogo';

interface BaseLayoutProps {
  children: React.ReactNode;
}

const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen w-full bg-white">
      <section className="flex min-h-screen max-w-screen overflow-x-hidden">
        {/* Left Content — Form Area */}
        <div className="flex flex-1 flex-col w-full xl:max-w-[33.33%] bg-white px-16 py-10">
          <div className="flex flex-1 flex-col justify-center py-8 xl:contents">
            <div className="mb-8 flex justify-center xl:justify-start">
              <Link to="/" className="inline-flex">
                <IronviewLogo className="w-56" />
              </Link>
            </div>

            <div className="flex items-center justify-center xl:flex-grow xl:py-8">
              {children}
            </div>
          </div>

          <footer className="py-4 text-center">
            <a
              href="https://ironview360.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-neutral-500 hover:text-neutral-800 transition-colors"
            >
              © {new Date().getFullYear()} Ironview 360
            </a>
          </footer>
        </div>

        {/* Middle & Right Sections */}
        <div className="relative hidden xl:flex flex-1 overflow-hidden xl:max-w-[66.67%]">
          <div className="absolute inset-0">
            <img
              src="/static/images/sf2_800.webp"
              alt="Background"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-br from-primary-700/90 to-primary-900/80 z-10" />

          {/* Middle Section Content */}
          <div className="absolute inset-0 z-20 flex items-center p-16 text-white w-1/2">
            <div className="max-w-xl">
              <h2 className="text-4xl font-bold mb-6 leading-tight">
                Take your jobsite virtual
              </h2>
              <p className="text-lg leading-relaxed opacity-90">
                Ironview 360 provides the most comprehensive construction documentation platform.
                Document and track your project progress virtually, keeping teams on schedule and
                budget with precise, full-service site documentation.
              </p>
            </div>
          </div>

          {/* Right Section — 360 Panorama */}
          <div className="absolute right-0 top-0 z-20 w-1/2 h-full flex items-center justify-center p-8">
            <div className="relative w-[90%] h-[90vh] overflow-hidden rounded-lg border-2 border-white/20">
              <PannellumViewer
                src="/static/images/panorama_asbuild.jpg"
                autoRotate={-10}
                draggable
                hfov={100}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BaseLayout;
